import { type AxiosRequestConfig } from 'axios';

import { fetchApi } from '../../services';
import { getSaviApiUrlLists } from '../../services/ispmUtil';
import { type SaveChartRequest, type SaveChartResponse } from '../types';

const { DASHBOARD_URL } = getSaviApiUrlLists(false);

function isSaveChartResponse(data: unknown): data is SaveChartResponse {
  return typeof data === 'object' && data !== null;
}

// Function to fetch ISPM suggestions
const saveChartToDashboard = async (
  request: SaveChartRequest,
  url?: string
): Promise<SaveChartResponse> => {
  const dashboardUrl = url ?? DASHBOARD_URL;
  const config: AxiosRequestConfig = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: request,
  };

  const response = await fetchApi(dashboardUrl, config, isSaveChartResponse);

  return response;
};

export default saveChartToDashboard;
